/**
 * Client-side RBAC helper — allineato a can_user_manage_staff() del backend
 * (/app/backend/auth.py). Non è la fonte di verità (il backend impone i check),
 * ma serve per nascondere/mostrare i bottoni evitando dead-end UX.
 */
const HK_HINTS = ["housekeeping", "cameriera", "cameriere", "pulizie",
                  "governante", "housekeeping_manager", "camerier", "hk"];
const FO_HINTS = ["front_office", "front office", "receptionist", "portiere",
                  "night_auditor", "night auditor", "front_office_manager", "fo"];

function matchesAny(roleLower, hints) {
  return hints.some((h) => roleLower.includes(h));
}

export function canUserManageStaff(user, staff) {
  if (!user || !staff) return false;
  const role = user.role;
  if (role === "super_admin") return true;
  if (role === "read_only") return false;
  const hotelIds = user.hotel_ids || [];
  if (!hotelIds.includes(staff.hotel_id)) return false;
  if (role === "capo_area" || role === "resident_manager") return true;
  const staffRole = (staff.ruolo || "").toString().trim().toLowerCase().replace(/-/g, "_");
  if (role === "housekeeping_manager") return matchesAny(staffRole, HK_HINTS);
  if (role === "front_office_manager") return matchesAny(staffRole, FO_HINTS);
  return false;
}
